import { EXTERNAL_PATH } from '@src/constants/constant';
import { NavigationTypes } from '@src/types/types';

import { IcoSound } from '@src/assets/svg';

const aiSummaryNavTree: NavigationTypes[] = [
  {
    key: 'AISummary',
    path: `${EXTERNAL_PATH}/ai-summary`,
    title: '실시간 검색어 AI 요약',
    icon: IcoSound,
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfig = [...aiSummaryNavTree];

export default [...navigationConfig];
export { navigationConfig };
